// externals
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

// libraries
import { ArrowTopRightOnSquareIcon } from '@interstate/components/Icons';
import * as configSelectors from '@makemydeal/dr-dash-store/selectors/config';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';
import { featureToggleSelectors, dealerSelectors } from '@makemydeal/dr-shared-store';
import { HostEnvironment, MANAGER_VIEW_APP_PREFIX, hostUrlHelper, locHrefUtil } from '@makemydeal/dr-shared-ui-utils';

// styles
import {
    CreditAndFinanceWrapper,
    CreditBureauContainer,
    DeepLinkDealertrack,
    DeepLinkDealertrackContainer,
    IconAndWidgetWrapper,
    LenderDecisionContainer
} from './CreditBureau.style';

// components
import LenderDecisionInfo from './LenderDecisionInfo';

export const CreditBureau = () => {
    const toggleEnableLenderDecisionsInCreditBureau = useSelector(featureToggleSelectors.isEnableLenderDecisionsInCreditBureau);
    const creditProviderIsRouteOne = useSelector(dealerSelectors.isCreditProviderRouteOne);
    const isRouteOneCreditBureauHidden = useSelector(featureToggleSelectors.enableHideRouteOneCreditBureau);
    const hideCreditBureauComponent = creditProviderIsRouteOne && isRouteOneCreditBureauHidden;
    const dealRefId = useSelector(offerSelectors.getDealRefId);
    const configUrl = useSelector(configSelectors.getDealertrackUrl);
    const isDealXgRecordMissed = useSelector(offerReduxSelectors.getIsDealXgRecordMissed);
    const hasCustomer = Boolean(useSelector(offerSelectors.getOfferCommonConsumerId));
    const isDealerTrackLinkDisabled = isDealXgRecordMissed || !hasCustomer;
    const environment = hostUrlHelper.getHostUrlEnvironment(MANAGER_VIEW_APP_PREFIX, locHrefUtil.getLocHref());
    const env = useMemo(() => (environment === HostEnvironment.Prod ? 'prod' : 'uat'), [environment]);

    const parseUnifiDeepLinkFromConfigUrl = (configUrl: any) => {
        if (configUrl.length > 0) {
            configUrl = `${configUrl}/credit_bureau_details/FD/${dealRefId}/`;
        }
        return configUrl;
    };

    const openUniFiDeepLinkUrl = () => {
        if (isDealerTrackLinkDisabled) {
            return;
        }
        const url: string = parseUnifiDeepLinkFromConfigUrl(configUrl);
        window.open(url, '_blank');
    };

    return (
        <>
            <CreditBureauContainer data-testid="credit-bureau-card">
                <CreditAndFinanceWrapper>
                    <IconAndWidgetWrapper data-testid="widget-wrapper">
                        {hideCreditBureauComponent === false && (
                            <DeepLinkDealertrackContainer>
                                <DeepLinkDealertrack
                                    onClick={openUniFiDeepLinkUrl}
                                    data-testid="anchorCreditBureau"
                                    $isDisabled={isDealerTrackLinkDisabled}
                                >
                                    <div>
                                        <ArrowTopRightOnSquareIcon />
                                    </div>
                                    <span>Open Dealertrack</span>
                                </DeepLinkDealertrack>
                            </DeepLinkDealertrackContainer>
                        )}
                        {hideCreditBureauComponent === false && (
                            <fni-credit-bureau-widget deal-ref-id={dealRefId} env={env} applicant="A" />
                        )}
                    </IconAndWidgetWrapper>

                    {creditProviderIsRouteOne && toggleEnableLenderDecisionsInCreditBureau && (
                        <LenderDecisionContainer data-testid="lender-decision-container">
                            <LenderDecisionInfo data-testid="lender-decision-layout" />
                        </LenderDecisionContainer>
                    )}
                </CreditAndFinanceWrapper>
            </CreditBureauContainer>
        </>
    );
};
